<template>
  <div>
    <div v-if="document.subcorpus === 'Learners'" class="row">
      <div class="col-sm-3" v-for="field in $ncsConfig.cedel2.fields.Learners">
        <b>{{$t(`result.context.header.document.${field}`)}}:</b> {{$ncsConfig.fieldValue(document[field])}}
      </div>
    </div>
    <div v-else class="row">
      <div class="col-sm-3" v-for="field in $ncsConfig.cedel2.fields.Native">
        <b>{{$t(`result.context.header.document.${field}`)}}:</b> {{$ncsConfig.fieldValue(document[field])}}
      </div>
    </div>
    <vue-plyr v-if="document.medium === 'Spoken'" :options="{controls: ['play', 'progress', 'current-time', 'mute', 'volume']}">
      <audio :src="`./audio/${document.filename}.mp3`" preload="none"/>
    </vue-plyr>
  </div>
</template>
<script>
  export default {
    props: ['document', 'text']
  }
</script>
